import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError, EMPTY, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoaderService } from '../_services/loader.service';

export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  const isPrivate = request.url.includes('/private/') || request.url.includes('/api/v1/internal/');

  return next.handle(request).pipe(
    catchError((error: HttpErrorResponse) => {
      let body = error.error;

      // 1. FORCED PARSING: If the body is a string, turn it into an object
      if (typeof body === 'string') {
        try {
          body = JSON.parse(body);
        } catch (e) {
          console.error("Could not parse error body", e);
        }
      }

      // 2. THE SILENCER: Check the parsed body for the 438 code
      // We check HTTP 500 AND the internal errorCode 438
      if (error.status === 500 && body && body.errorCode == 438) {
        console.log("Success! Ignored 500/438 error.");
        // MUST use 'of' and 'new HttpResponse' so the component's 'response =>' block triggers
        return of(new HttpResponse({ 
          body: body, 
          status: 500 
        }));
      }

      // 3. FALLBACK LOGIC: For all other errors
      let errorMessage = body?.message || 'An error occurred.';
      let displayCode = body?.errorCode || error.status || 500;

      if (isPrivate) {
        this.loaderService.load(displayCode, errorMessage);
        return throwError(() => new Error(errorMessage));
      } else {
        this.loaderService.show(displayCode, errorMessage);
        return throwError(() => new Error(errorMessage));
      }
    })
  );
}
}